import React from "react";

// R0AM wordmark with the stylized "0" as a protected compass/waypoint node.
export function Logo({ className = "", size = "md", showBy = true, testId = "logo" }) {
  const sizes = {
    sm: { text: "text-lg", ring: 16, by: "text-[9px]" },
    md: { text: "text-2xl", ring: 22, by: "text-[10px]" },
    lg: { text: "text-4xl sm:text-5xl", ring: 36, by: "text-xs" },
  };
  const s = sizes[size] || sizes.md;
  return (
    <div className={`inline-flex flex-col leading-none ${className}`} data-testid={testId}>
      <div className={`flex items-center font-display font-extrabold tracking-tight ${s.text}`}>
        <span className="text-white">R</span>
        <ZeroMark px={s.ring} />
        <span className="text-white">AM</span>
      </div>
      {showBy && (
        <span className={`mt-1 font-sans font-medium tracking-[0.3em] uppercase text-gold/80 ${s.by}`}>
          by Wadiah Mutual
        </span>
      )}
    </div>
  );
}

function ZeroMark({ px = 22 }) {
  return (
    <span
      className="relative inline-flex items-center justify-center mx-[1px]"
      style={{ width: px, height: px }}
      aria-label="0"
    >
      <svg viewBox="0 0 40 40" width={px} height={px} fill="none">
        <circle cx="20" cy="20" r="16" stroke="#D4AF37" strokeWidth="3" />
        <circle cx="20" cy="20" r="16" stroke="#0055FF" strokeWidth="3" strokeDasharray="8 60" />
        <circle cx="20" cy="20" r="4.5" fill="#D4AF37" />
        <line x1="20" y1="0" x2="20" y2="6" stroke="#D4AF37" strokeWidth="2.5" />
        <line x1="20" y1="34" x2="20" y2="40" stroke="#0055FF" strokeWidth="2.5" />
      </svg>
    </span>
  );
}

export default Logo;
